// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen{div.footer[data-v-7453689c]{display:none}}@media print{div.footer[data-v-7453689c]{border-top:2px solid #f47ba9;bottom:0;margin-top:10px;position:fixed}div.footer p[data-v-7453689c]{text-align:center}}table[data-v-7453689c]{border-collapse:collapse}thead[data-v-7453689c]{display:table-row-group}tr td[data-v-7453689c]{page-break-inside:avoid}.no-border[data-v-7453689c]{border:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
